module.exports = __webpack_public_path__ + "static/media/5ed7b13c72f4e5e57a748794.49986a85.png";